import { CircularProgress } from "@mui/material";
import { useQuestionnaireListContext } from "../context/useQuestionnaireList";
import { ListView } from "./ListView";
import { GridView } from "./GridView";

export const ViewSwitch = () => {
    const { isSsqLoading, view } = useQuestionnaireListContext();

    if (isSsqLoading) {
        return <CircularProgress sx={{ margin: "0 auto" }} />;
    }

    if (view === "list") {
        return <ListView />;
    }

    return <GridView />;
};
